import { defineComponent } from "@vue/composition-api";
import PlanMessage from "./plan-message.vue";
import PlanBoxes from "./plan-boxes.vue";
export default defineComponent({
  name: "CurrentAccountContainer",
  components: {
    PlanMessage,
    PlanBoxes
  },
  props: {
    paymentFailure: {
      type: String,
      default: ""
    }
  }
});